// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".8b6006d4a8b33af2cf5b2c589489bd6a.js";
};